import { createSlice } from '@reduxjs/toolkit';
import { defaultDescription } from './util';

const initialState = {
  isLoading: false,
  isError: false,
  isCustomerModalDisplayed: false,
  order: {
    priceOffersId: null,
    saleDate: null,
    deliveryDate: null,
    description: defaultDescription,
    balanceDate: null,
    balanceReceived: 0,
    balanceUserId: null,
    balanceRemainder: null,
    paymentMethod: 'Belirlenmedi',
    bill: 'Kesilmedi',
    billingAddress: null,
    salesChannel: 'Belirlenmedi',
    subSalesChannel: 'Belirlenmedi',
    order_status_id: null,
    deliveryOption: 'Mağazadan Teslim',
    productsTotal: 0,
    discountRate: 0,
    kdv: 18,
    kdvTotal: 0,
    subTotal: 0,
    discountTotal: 0,
    total: 0,
    users_id: null,
    orderManagerId: null,
  },
  editingCustomer: {
    name: '',
    lastName: '',
    company: '',
    email: '',
    phone: '',
    address: '',
    billingAddress: '',
  },
  products: [],
  selectedProduct: null,
  imageLink: 'https://via.placeholder.com/150',
};

export const createOrderSlice = createSlice({
  name: 'createOrder',
  initialState,
  reducers: {
    START_LOADING: (state) => {
      return { ...state, isLoading: true };
    },
    STOP_LOADING: (state) => {
      return { ...state, isLoading: false };
    },

    SET_ERROR: (state) => {
      return { ...state, isError: true };
    },
    CLEAR_ERROR: (state) => {
      return { ...state, isError: false };
    },

    SET_PRICE_OFFER_ID: (state, action) => {
      return { ...state, order: { ...state.order, priceOffersId: action.payload } };
    },
    SHOW_CUSTOMER_MODAL: (state) => {
      return { ...state, isCustomerModalDisplayed: true };
    },
    HIDE_CUSTOMER_MODAL: (state) => {
      return { ...state, isCustomerModalDisplayed: false };
    },
    SET_CUSTOMER_NAME: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, name: action.payload } };
    },
    SET_CUSTOMER_LAST_NAME: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, lastName: action.payload } };
    },
    SET_CUSTOMER_COMPANY: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, company: action.payload } };
    },
    SET_CUSTOMER_EMAIL: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, email: action.payload } };
    },
    SET_CUSTOMER_PHONE: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, phone: action.payload } };
    },
    SET_CUSTOMER_ADDRESS: (state, action) => {
      return { ...state, editingCustomer: { ...state.editingCustomer, address: action.payload } };
    },
    SET_CUSTOMER_BILLING_ADDRESS: (state, action) => {
      return {
        ...state,
        editingCustomer: { ...state.editingCustomer, billingAddress: action.payload },
      };
    },
    SET_CUSTOMER: (state, action) => {
      return {
        ...state,
        editingCustomer: action.payload,
        order: { ...state.order, billingAddress: action.payload.billingAddress },
      };
    },
    SET_USER: (state, action) => {
      return {
        ...state,
        order: { ...state.order, users_id: action.payload },
      };
    },
    SET_ORDER_MANAGER: (state, action) => {
      return {
        ...state,
        order: { ...state.order, orderManagerId: action.payload },
      };
    },
    SET_ORDER_STATUS: (state, action) => {
      return {
        ...state,
        order: { ...state.order, order_status_id: action.payload },
      };
    },
    SET_DELIVERY_OPTION: (state, action) => {
      return {
        ...state,
        order: { ...state.order, deliveryOption: action.payload },
      };
    },
    SET_SALES_CHANNEL: (state, action) => {
      return {
        ...state,
        order: { ...state.order, salesChannel: action.payload },
      };
    },
    SET_SUB_SALES_CHANNEL: (state, action) => {
      return {
        ...state,
        order: { ...state.order, subSalesChannel: action.payload },
      };
    },
    SET_SALE_DATE: (state, action) => {
      return {
        ...state,
        order: { ...state.order, saleDate: action.payload },
      };
    },
    SET_DELIVERY_DATE: (state, action) => {
      return {
        ...state,
        order: { ...state.order, deliveryDate: action.payload },
      };
    },
    SET_PRODUCTS: (state, action) => {
      return { ...state, products: action.payload };
    },
    PICK_PRODUCT: (state, action) => {
      return { ...state, selectedProduct: action.payload };
    },
    SET_IMAGE_LINK: (state, action) => {
      return { ...state, imageLink: action.payload };
    },
    ADD_PRODUCT: (state, action) => {
      return {
        ...state,
        products: [
          ...state.products,
          {
            ...action.payload,
            quantity: 1,
            glass: '',
            lampholder: '',
            branch: '',
            color: '',
            material: '',
            features: '',
            specialNotes: '',
          },
        ],
      };
    },
    ADD_PRODUCT_FROM_PRICE_OFFER: (state, action) => {
      return {
        ...state,
        products: [
          ...state.products,
          {
            ...action.payload,
          },
        ],
      };
    },
    REMOVE_PRODUCT: (state, action) => {
      return {
        ...state,
        products: state.products.filter((product, index) => index !== action.payload),
      };
    },
    SET_PRODUCT_DETAIL: (state, action) => {
      return {
        ...state,
        products: state.products.map((product, index) => {
          if (index === action.payload.index) {
            if (action.payload.field === 'price') {
              return {
                ...product,
                price: parseFloat(action.payload.value),
                total: parseFloat(action.payload.value) * product.quantity,
              };
            }
            if (action.payload.field === 'quantity') {
              return {
                ...product,
                quantity: parseInt(action.payload.value),
                total: parseFloat(product.price) * parseInt(action.payload.value),
                // [action.payload.field]: action.payload.value,
              };
            }
            if (action.payload.field === 'selectedVariant') {
              if (action.payload.value.id) {
                return {
                  ...product,
                  imageLink: action.payload.value.image_link || product.baseImageLink,
                  price: parseFloat(action.payload.value.price),
                  total: parseFloat(action.payload.value.price) * parseInt(product.quantity),
                  [action.payload.field]: action.payload.value,
                };
              }
              return {
                ...product,
                [action.payload.field]: action.payload.value,
                price: action.payload.value.price,
                imageLink: action.payload.value.imageLink,
              };
            }
            return { ...product, [action.payload.field]: action.payload.value };
          }
          return product;
        }),
      };
    },
    SET_ORDER_DESCRIPTION: (state, action) => {
      return { ...state, order: { ...state.order, description: action.payload } };
    },
    SET_MANUFACTURER: (state, action) => {
      return {
        ...state,

        products: state.products.map((item, index) => {
          if (action.payload.index === index) {
            return { ...item, manufacturers_id: action.payload.value };
          }
          return item;
        }),
      };
    },
    SET_PRODUCTS_TOTAL: (state, action) => {
      return { ...state, order: { ...state.order, productsTotal: parseFloat(action.payload) } };
    },
    SET_DISCOUNT_RATE: (state, action) => {
      return {
        ...state,
        order: {
          ...state.order,
          discountRate: parseFloat(action.payload),
        },
      };
    },
    SET_DISCOUNT_TOTAL: (state, action) => {
      return {
        ...state,
        order: {
          ...state.order,
          discountTotal: parseFloat(action.payload),
        },
      };
    },
    SET_KDV_TOTAL: (state, action) => {
      return { ...state, order: { ...state.order, kdvTotal: parseFloat(action.payload) } };
    },
    SET_SUBTOTAL: (state, action) => {
      return {
        ...state,
        order: {
          ...state.order,
          subTotal: parseFloat(action.payload),
          total: parseFloat(action.payload) * 1.18,
        },
      };
    },
    SET_TOTAL: (state, action) => {
      return {
        ...state,
        order: {
          ...state.order,
          total: parseFloat(action.payload),
          balanceRemainder: parseFloat(action.payload) - state.order.balanceReceived,
        },
      };
    },
    SET_ORDER_BALANCE_DATE: (state, action) => {
      return { ...state, order: { ...state.order, balanceDate: action.payload } };
    },
    SET_ORDER_BALANCE_RECEIVED: (state, action) => {
      return {
        ...state,
        order: {
          ...state.order,
          balanceReceived: parseFloat(action.payload),
        },
      };
    },
    SET_ORDER_BALANCE_USER: (state, action) => {
      return { ...state, order: { ...state.order, balanceUserId: action.payload } };
    },
    SET_ORDER_BALANCE_REMAINDER: (state, action) => {
      return {
        ...state,
        order: { ...state.order, balanceRemainder: state.order.total - parseFloat(action.payload) },
      };
    },
    SET_ORDER_PAYMENT_METHOD: (state, action) => {
      return { ...state, order: { ...state.order, paymentMethod: action.payload } };
    },
    SET_ORDER_BILL: (state, action) => {
      return { ...state, order: { ...state.order, bill: action.payload } };
    },
    RESET: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const {
  START_LOADING,
  STOP_LOADING,
  SET_PRICE_OFFER_ID,
  SET_ERROR,
  CLEAR_ERROR,
  SHOW_CUSTOMER_MODAL,
  HIDE_CUSTOMER_MODAL,
  SET_CUSTOMER,
  SET_CUSTOMER_NAME,
  SET_CUSTOMER_LAST_NAME,
  SET_CUSTOMER_COMPANY,
  SET_CUSTOMER_EMAIL,
  SET_CUSTOMER_PHONE,
  SET_CUSTOMER_ADDRESS,
  SET_CUSTOMER_BILLING_ADDRESS,
  SET_USER,
  SET_ORDER_MANAGER,
  SET_ORDER_STATUS,
  SET_DELIVERY_OPTION,
  SET_SALES_CHANNEL,
  SET_SUB_SALES_CHANNEL,
  SET_SALE_DATE,
  SET_DELIVERY_DATE,
  SET_PRODUCTS,
  PICK_PRODUCT,
  SET_IMAGE_LINK,
  ADD_PRODUCT,
  ADD_PRODUCT_FROM_PRICE_OFFER,
  REMOVE_PRODUCT,
  SET_PRODUCT_DETAIL,
  SET_ORDER_DESCRIPTION,
  SET_MANUFACTURER,
  SET_DISCOUNT_RATE,
  SET_DISCOUNT_TOTAL,
  SET_KDV_TOTAL,
  SET_PRODUCTS_TOTAL,
  SET_SUBTOTAL,
  SET_TOTAL,
  SET_ORDER_BALANCE_DATE,
  SET_ORDER_BALANCE_RECEIVED,
  SET_ORDER_BALANCE_USER,
  SET_ORDER_BALANCE_REMAINDER,
  SET_ORDER_PAYMENT_METHOD,
  SET_ORDER_BILL,
  RESET,
} = createOrderSlice.actions;

export default createOrderSlice.reducer;
